import { PackagesService } from "../../../../../services/packages.service";
import { BankCardsServices } from "../../../../../services/bankCards.service";
import MainButton from "../../../../shared/button/MainButton";
import GlobalModalComponent from "../../../../shared/globalModal/GlobalModalComponent";
import CardSelectModal from "../../../../shared/card-select-modal/CardSelectModal";
import PaymentStatusModal from "../../../../shared/payment-status-modal/PaymentStatusModal";
import styles from "./PaymentModal.module.scss";
import closeIcon from "../../../../../assets/images/referal/Close Icon.svg";
import { toast } from "react-toastify";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../../../redux/store";

import { BankCardType } from "../../../../../interface/site.interface";
import NoCardsModal from "../../../../shared/no-cards-modal/NoCardsModal";

interface paymentProps {
  paymentModalOpen: boolean;
  setPaymentModalOpen: (value: boolean) => void;
  checkedCards: number[];
  setWarningModalOpen: (value: boolean) => void;
  fetchPackagesType?: () => void;
  fetchPackages?: () => void;
  setModalContent: React.Dispatch<React.SetStateAction<any>>;
  onPaymentSuccess: () => void;
  totalAmount?: string;
}

const PaymentModal = ({
  paymentModalOpen,
  setPaymentModalOpen,
  fetchPackages,
  checkedCards,
  setWarningModalOpen,
  setModalContent,
  fetchPackagesType,
  onPaymentSuccess,
  totalAmount,
}: paymentProps) => {
  const [isPaying, setIsPaying] = useState(false);
  const [isCardModalOpen, setIsCardModalOpen] = useState(false);
  const [cards, setCards] = useState<BankCardType[]>([]);
  const [isPaymentStatusOpen, setIsPaymentStatusOpen] = useState(false);
  const [paymentSuccess, setPaymentSuccess] = useState(false);
  const [isCardPaymentLoading, setIsCardPaymentLoading] = useState(false);
  const [paymentErrorMessage, setPaymentErrorMessage] = useState<string>("");
  const [isNoCardsModalOpen, setIsNoCardsModalOpen] = useState(false);
  const { data } = useSelector((state: RootState) => state.translationData);


  const isZeroAmount =
    totalAmount === "0" ||
    totalAmount === "0.00" ||
    parseFloat(totalAmount || "0") === 0;

  const handlePayPackages = async () => {
    setIsPaying(true);
    try {
      const response = await PackagesService.payPackages(checkedCards);
      if (response?.data?.original?.case === "warning") {
        toast.error(data?.payment_error);
      } else {
        toast.success(data?.payment_success);
        fetchPackagesType?.();
        fetchPackages?.();
        onPaymentSuccess();
      }
    } catch (error: any) {
      setWarningModalOpen(true);
      const errorMessages = error.response?.data?.original;
      setModalContent({
        title: errorMessages?.title,
        content: errorMessages?.content,
        amount_paid: errorMessages?.amount_paid,
        balance: errorMessages?.balance,
        currency: errorMessages?.currency,
        debt: errorMessages?.debt,
      });
    } finally {
      setIsPaying(false);
      setPaymentModalOpen(false);
    }
  };

  const handlePayPackagesWithBankClick = async () => {
    setIsPaying(true);
    try {
      const response = await BankCardsServices.getBankCards();
      const cardsList = response.data?.data || [];

      if (cardsList.length === 0) {
        setPaymentModalOpen(false);
        setIsNoCardsModalOpen(true);
        return;
      }

      setCards(cardsList);
      setPaymentModalOpen(false);
      setIsCardModalOpen(true);
    } catch (error) {
      console.error("Kartlar yuklenirken xeta:", error);
      setPaymentModalOpen(false);
      setIsNoCardsModalOpen(true);
    } finally {
      setIsPaying(false);
    }
  };

  const handleCardSelect = async (cardId: number) => {
    setIsCardPaymentLoading(true);
    try {
      const response = await PackagesService.payPackagesWithBank(
        checkedCards,
        cardId,
        "card"
      );

      const original = response?.data?.original;

      if (original?.success === false || original?.status === "error") {
        setPaymentErrorMessage(original?.message || "");
        setPaymentSuccess(false);
        setIsPaymentStatusOpen(true);
      } else if (
        original?.case === "success" ||
        response?.data?.success
      ) {
        setPaymentErrorMessage("");
        setPaymentSuccess(true);
        setIsPaymentStatusOpen(true);
        fetchPackagesType?.();
        fetchPackages?.();
      } else if (original?.case === "warning") {
        setPaymentErrorMessage(original?.message || original?.content || "");
        setPaymentSuccess(false);
        setIsPaymentStatusOpen(true);
      } else {
        setPaymentErrorMessage("");
        setPaymentSuccess(true);
        setIsPaymentStatusOpen(true);
        fetchPackagesType?.();
        fetchPackages?.();
      }
    } catch (error: any) {
      console.error("Kart odenisi xetasi:", error);
      const errorMessages = error.response?.data?.original || error?.original;
      const errMsg = errorMessages?.message || errorMessages?.content;
      setPaymentErrorMessage(typeof errMsg === "string" ? errMsg : "");
      setPaymentSuccess(false);
      setIsPaymentStatusOpen(true);

      if (errorMessages) {
        setModalContent({
          title: errorMessages?.title,
          content: errorMessages?.content,
          amount_paid: errorMessages?.amount_paid,
          balance: errorMessages?.balance,
          currency: errorMessages?.currency,
          debt: errorMessages?.debt,
        });
      }
    } finally {
      setIsCardPaymentLoading(false);
      setIsCardModalOpen(false);
    }
  };

  const handlePayWithDirectPay = async () => {
    setIsPaying(true);
    try {
      const response = await PackagesService.payPackagesWithBank(checkedCards, undefined, 'yigim_direct');
      const original = response?.data?.original;
      if (original?.case === 'success' && original?.url) {
        window.location.href = original.url;
      } else {
        toast.error(original?.content || data?.payment_error);
      }
    } catch (error: any) {
      const errorMessages = error.response?.data?.original;
      toast.error(errorMessages?.content || data?.payment_error);
    } finally {
      setIsPaying(false);
      setPaymentModalOpen(false);
    }
  };

  const handlePayWithPasha = async () => {
    setIsPaying(true);
    try {
      const response = await PackagesService.payPackagesWithBank(
        checkedCards,
        undefined,
        "pasha"
      );

      const original = response?.data?.original;

      if (
        original?.case === "success" &&
        original?.content &&
        original?.content.startsWith("http")
      ) {
        window.location.href = original.content;
      } else if (original?.case === "success") {
        setPaymentSuccess(true);
        setIsPaymentStatusOpen(true);
        fetchPackagesType?.();
        fetchPackages?.();
        onPaymentSuccess();
      } else {
        toast.error(original?.content || data?.payment_error);
      }
    } catch (error: any) {
      const errorMessages = error.response?.data?.original;
      if (errorMessages?.content) {
        toast.error(errorMessages.content);
      } else {
        toast.error(data?.payment_error);
      }
    } finally {
      setIsPaying(false);
      setPaymentModalOpen(false);
    }
  };

  const handlePaymentRedirect = () => {
    setIsPaymentStatusOpen(false);
    if (paymentSuccess) {
      onPaymentSuccess();
    }
  };

  const handlePaymentStatusClose = () => {
    setIsPaymentStatusOpen(false);
    if (!paymentSuccess) {
      setWarningModalOpen(true);
    }
  };

  return (
    <>
      <GlobalModalComponent
        isOpen={paymentModalOpen}
        onClose={() => setPaymentModalOpen(false)}
      >
        <div className={styles.paymentModal}>
          <div
            className={styles.close}
            onClick={() => setPaymentModalOpen(false)}
          >
            <img src={closeIcon} alt="x" />
          </div>
          <h3 className={styles.title}>{data?.package_payment}</h3>

          {totalAmount && (
            <div className={styles.amountInfo}>
              <div className={styles.amountRow}>
                <span className={styles.amountLabel}>
                  {data?.total_amount || "Cəmi"}:
                </span>
                <span className={styles.amountValue}>{totalAmount} USD</span>
              </div>
            </div>
          )}

          <div className={styles.paymentButtons}>
            {isZeroAmount ? (
              <MainButton
                className={styles.BalancePay}
                text={isPaying ? "..." : data?.auth_promocode_confirm || "Təsdiqlə"}
                onClick={handlePayPackages}
                disabled={isPaying}
              />
            ) : (
              <>
                <MainButton
                  className={styles.BalancePay}
                  text={data?.pay_from_balance}
                  onClick={handlePayPackages}
                  disabled={isPaying}
                />
                <MainButton
                  className={styles.KartPay}
                  text={isPaying ? "..." : data?.pay_by_card}
                  onClick={handlePayPackagesWithBankClick}
                  disabled={isPaying}
                />
                <MainButton
                  className={styles.DirectPay}
                  text={isPaying ? "..." : data?.direct_pay || "Birbaşa ödə"}
                  onClick={handlePayWithDirectPay}
                  disabled={isPaying}
                />
                {/* <MainButton
                  className={styles.PashaPay}
                  text={isPaying ? "..." : "Pasha Bank"}
                  onClick={handlePayWithPasha}
                  disabled={isPaying}
                /> */}
              </>
            )}
          </div>
        </div>
      </GlobalModalComponent>

      <CardSelectModal
        isOpen={isCardModalOpen}
        onClose={() => setIsCardModalOpen(false)}
        onSelectCard={handleCardSelect}
        cards={cards}
        isLoading={isCardPaymentLoading}
        amount={totalAmount}
        translationData={data}
      />

      <PaymentStatusModal
        isOpen={isPaymentStatusOpen}
        isSuccess={paymentSuccess}
        onClose={handlePaymentStatusClose}
        onRedirect={handlePaymentRedirect}
        errorMessage={paymentErrorMessage}
        translationData={data}
      />

      <NoCardsModal
        isOpen={isNoCardsModalOpen}
        onClose={() => setIsNoCardsModalOpen(false)}
        translationData={data}
      />
    </>
  );
};

export default PaymentModal;
